
import AuthPage from "../../components/layout/authPage"
import { useState } from "react";
import { OTPForm } from "../../components/otpForm";

export const OTPRegister = () => {
    const [token, setTokens] = useState();
    return (
        <AuthPage>
          <OTPForm type="phone" method="register"/>
        </AuthPage>
    )
}